import styled from 'styled-components';

const Divider = styled.div`
  border-bottom: 1px solid var(--darkGray);
  margin: 2rem auto;
`;

export default Divider;
